import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * PO 2026-02 · Trial Paywall V1 — locked screen shown when the
 * router-level product-access gate returns 402. Copy is PO-locked:
 * "Your JobClose AI free trial has ended. Your business information
 * has not been deleted." The CTA sends the contractor to `/app/account`
 * (Stripe checkout / manage billing) — that route is explicitly
 * bypassed by the paywall so the contractor can pay to restore access.
 */
export default function TrialExpiredScreen() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  return (
    <div
      data-testid="trial-expired-screen"
      className="min-h-screen flex items-center justify-center bg-[var(--jc-bg)] px-6 py-12"
    >
      <div className="w-full max-w-lg bg-white rounded-lg border border-gray-200 shadow-sm p-10">
        <div className="text-xs uppercase tracking-[0.18em] text-gray-500 mb-3">
          JobClose AI
        </div>
        <h1
          data-testid="trial-expired-title"
          className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight mb-4"
        >
          Your free trial has ended.
        </h1>
        <p
          data-testid="trial-expired-body"
          className="text-base text-gray-700 leading-relaxed mb-2"
        >
          Your JobClose AI free trial has ended. Your business
          information has not been deleted.
        </p>
        <p className="text-base text-gray-700 leading-relaxed mb-8">
          Reactivate anytime to restore full access to your projects,
          estimates, invoices, and business texting.
        </p>
        <button
          data-testid="trial-expired-reactivate-btn"
          onClick={() => navigate("/app/account")}
          className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 rounded-md bg-[#1652f0] hover:bg-[#0f3fbf] text-white font-semibold text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1652f0]"
        >
          Reactivate JobClose
        </button>
        <div className="mt-8 pt-6 border-t border-gray-200 flex items-center justify-between text-sm">
          <a
            data-testid="trial-expired-support-link"
            href="/app/support"
            className="text-[#1652f0] hover:underline"
          >
            Contact support
          </a>
          <button
            data-testid="trial-expired-logout-btn"
            onClick={logout}
            className="text-gray-500 hover:text-gray-700 underline"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
